module.exports = __webpack_public_path__ + "img/jieru1.428b607d.jpg";